import * as React from "react"
import * as moment from "moment"
import {ModalComponent} from "./ModalComponent";
import CTA, {CTATheme} from "./common/CallToAction";

interface IClearSlotSuccessModal {
    closeModal: () => void,
    startTime: number,
    endTime: number,
    patientName: string
}

const ClearSlotSuccessModal = (props: IClearSlotSuccessModal) => {

    return (
        <ModalComponent modalSize={"x-small"} className={"clear-slot-modal"}>
            <div className={"clear-slot-header"}>
                <img src="/images/icons/check.svg" />
                <div>Slot Cleared</div>
            </div>
            <div className={"clear-slot-subheader"}>
                {`You’ve been marked as unavailable for upcoming appointment with ${props.patientName}.`}
            </div>
            <br/>
            <div className={"clear-slot-subheader dark"}>
                {`Roaster blocked from ${moment(props.startTime).format("hh:mm")}-${moment(props.endTime).format("hh:mm")}`}
            </div>
            <div style={{display: "flex", justifyContent: "flex-end"}}>
                <CTA innerText={"Back To Calendar"} theme={CTATheme.PRIMARY} onClick={props.closeModal}/>
            </div>
        </ModalComponent>
    )
}

export default ClearSlotSuccessModal